
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import saveEmissionService from '@/apps/shared/services/saveEmission-service';
    import ParamCotiz from '@/apps/shared/services/ParamCotizOfSession-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';

    export default Vue.extend({
        name: 'APSummary',
        components: {
            XSummary,
            XBreadcrumb
        },
        data() {
            return {
                productDetails: {
                    GUiD: null,
                    product: "OcassionOfWork",
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/ocasion-de-trabajo' },
                        { text: 'Resumen', path: 'ocasion-de-trabajo/resumen' },
                    ],
                    icon: {
                        src: '/icons/apOcassionOfWork.svg',
                        alt: 'OcassionOfWork',
                        title: 'OcassionOfWork'
                    },
                } as SummaryDetails,
                product: null,
                saveEmissionRequest: null,
                referente: null,
                medium: null,
            }
        },
        methods: {
            async pageCustomization() {
                var product = sessionStorage.getItem('productId');
                let defaultTitle = '';
                let actualPath = '';
                let icon = '';
                switch (product) {
                    case '711': defaultTitle = 'Integro Max'; this.productName = "apintegro"; actualPath = '/integro-max'; icon = "/Logos/AP_Integro.svg"; this.product = "apintegro"; break;
                    case '555': defaultTitle = 'Ocasión de Trabajo'; this.productName = "aptrabajo"; actualPath = '/ocasion-de-trabajo'; icon = "/Logos/AP_OT.svg"; this.product = "aptrabajo"; break;
                    case '387': defaultTitle = 'AP - 24HS'; this.productName = "ap24"; actualPath = '/ap-24-hs'; icon = "/Logos/AP_24.svg"; this.product = "ap24"; break;
                }
                const actualStep = 'summary';
                this.productDetails.icon.src = icon

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            getCUPE() {
                const email = "";
                const productId = sessionStorage.getItem('productId');
                NF.UI.Page.block();
                return CUPEService.GetCUPEUrl(productId, email, this.GUiD)
                    .then(response => {
                        this.productDetails.cupeUrl = response.preferenceMessage;
                    })
                    .catch((error) => {
                        console.error('Error al obtener la URL:', error);
                    })
                    .finally(() => {
                        NF.UI.Page.unblock();
                    });
            },

            SaveEmission() {
                const owner = JSON.parse(sessionStorage.getItem("contratante"));
                const pricingId = JSON.parse(sessionStorage.getItem("PlanSelected")).pricingId;
                const peopleInsured = JSON.parse(sessionStorage.getItem("insuredPeople"));
                const repeticionPeople = JSON.parse(sessionStorage.getItem("repeticionPeople"));
                const subrogacionPeople = JSON.parse(sessionStorage.getItem("subrogacionPeople"));

                const usingFront = owner?.addresFromFront === true;

                const request = {
                    PricingId: pricingId,
                    Birthday: new Date(owner.birthday),
                    CityCode: null,
                    ClientFirstName: owner.firstName ? owner.firstName : "",
                    ClientLastName: owner.lastName,
                    DocumentNumber: Number(owner.document.identificationNumber),
                    DocumentType: owner.document.identificationTypeCode,
                    EffectDate: new Date(),
                    ClientAddress: {},
                    Email: JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    Phones: [{ areaCode: owner.areaCode, phoneNumber: owner.telephone }],
                    ProducerCode: null,
                    ReceivePromotion: false,
                    RiskAddress: {},
                    ZipCode: null,
                    SubRogacion: subrogacionPeople,
                    NoRepeticion: repeticionPeople,
                    PeopleToCover: peopleInsured,
                };

                if (usingFront) {
                    request.ClientAddress = {
                        StreetName: owner.streetName,
                        StreetNumber: owner.numDom,
                        City: { CityPostalCode: owner.zipCode }
                    };
                    request.CityCode = owner.localityId;
                }
                this.saveEmissionRequest = request;
                return saveEmissionService.APSaveEmission(JSON.stringify(request));
            },

            formatDate(dateString: string) {
                if (!dateString) {
                    return "";
                }
                dateString = dateString.replace(/^"|"$/g, '');
                const [year, month, day] = dateString.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            },

            setSessionParams() {
                const rawProductId = sessionStorage.getItem('productId');
                const rawContratante = JSON.parse(sessionStorage.getItem('contratante')!);
                const rawPlan = JSON.parse(sessionStorage.getItem('PlanSelected')!);
                const rawTabTwo = JSON.parse(sessionStorage.getItem('TabTwoData')!);
                const rawPersonData = JSON.parse(sessionStorage.getItem("TabOneWelcome")!);
                const rawQuotaQuantity = JSON.parse(sessionStorage.getItem("quotaQuantity")!);

                const payload = {
                    productId: rawProductId,
                    contratante: {
                        firstName: rawContratante.firstName,
                        lastName: rawContratante.lastName,
                        documentNumber: rawContratante.document.identificationNumber,
                        documentType: rawContratante.document.identificationTypeCode,
                        areaCode: rawContratante.areaCode,
                        telephone: rawContratante.telephone,
                        email: rawContratante.email
                    },
                    plan: {
                        PlanName: rawPlan.PlanName,
                    },                    
                    localityId: parseInt(rawPersonData.selectedLocality.id),
                    quotaQuantity: rawQuotaQuantity,
                    activity: rawTabTwo.selectedActivity.activityDescription,
                    saveEmissionRequest: this.saveEmissionRequest,
                    referente: this.referente,
                    medium: this.medium,
                };

                const jsonString = JSON.stringify(payload);

                return ParamCotiz.setParamCotiz(payload)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            getInitData() {
                this.productDetails.effectDate = this.formatDate(sessionStorage.getItem("vigencyStart"));
                this.productDetails.expirationDate = this.formatDate(sessionStorage.getItem("vigencyEnd"));
                const personData = sessionStorage.getItem("contratante");
                const mail = JSON.parse(sessionStorage.getItem("TabOneWelcome")).email;
                const planDataSelected = sessionStorage.getItem("PlanSelected");

                if (personData != null) {
                    const person = JSON.parse(personData!);
                    this.productDetails.name = person.firstName ? person.firstName+ ' ' + person.lastName : "" + ' ' + person.lastName;
                    this.productDetails.email = mail;
                    this.productDetails.telephone = person.areaCode + '-' + person.telephone;
                }

                if (planDataSelected != null) {
                    const dataPlan = JSON.parse(planDataSelected!);
                    this.productDetails.planDescription = dataPlan.planName;
                    this.productDetails.firstPaymentFee = dataPlan.premioMensual;
                    this.productDetails.capital = null;
                    this.productDetails.undiscountedPrice = dataPlan.premiumWithoutDiscount;

                    const excluded = [
                        'Llamando al Doctor',
                        'Descuento en Farmacias + Alta Complejidad'
                    ];

                    const covers = dataPlan.calculosFinales
                        .filter(item =>
                            item.tipoDetalle === 'Cobertura' &&
                            !excluded.includes(item.descripcion)
                        )
                        .map(item => ({
                            coverDescription: item.descripcion.trim()
                        }));
                    this.productDetails.cover = covers;

                    NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                    DiscountRangeService.getWorkOcassionDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.productDetails.rate = response[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'Default' + this.product + 'GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },

        mounted: async function () {
            const product = sessionStorage.getItem('productId');

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;
            
            try {
                await this.pageCustomization();                
                this.updateByProductGoogleAnalytics();
                this.getInitData();

                await this.SaveEmission();
                await this.setSessionParams();
                await this.getCUPE();
            } catch (err) {
                const statusCode = err?.response?.status;
                this.Bus?.$emit('show-service-fail', statusCode, [() => this.mounted()]);
                console.error("Error en mounted:", err);
            }

            const email = JSON.parse(sessionStorage.getItem("contratante")).email;

            const eventData = {
                pas: null,
                email,
                product: this.product,
                event: 'cotizador-' + this.product + '-checkout',
                referente: this.referente,
                medio: this.medium
            };

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push(eventData);

            const customWindow = window as typeof window & {
                _qsie?: Array<typeof eventData>;
            };

            customWindow._qsie ??= [];
            customWindow._qsie.push(eventData);
        },
    });
